import { type ScopedThreadRef } from "@cmmd-forge/contracts";
import { type TerminalContextSelection } from "../../lib/terminalContext";
import { ExpandedImageDialog } from "./ExpandedImageDialog";
import { type ExpandedImagePreview } from "./ExpandedImagePreview";
import {
  PersistentThreadTerminalDrawer,
  type TerminalLaunchContext,
} from "./PersistentThreadTerminalDrawer";

export function ChatThreadOverlays(props: {
  readonly mountedTerminalThreadRefs: ReadonlyArray<{
    readonly key: string;
    readonly threadRef: ScopedThreadRef;
  }>;
  readonly activeThreadKey: string | null;
  readonly terminalOpen: boolean;
  readonly activeTerminalLaunchContext: TerminalLaunchContext | null;
  readonly terminalFocusRequestId: number;
  readonly splitTerminalShortcutLabel: string | null;
  readonly newTerminalShortcutLabel: string | null;
  readonly closeTerminalShortcutLabel: string | null;
  readonly onAddTerminalContext: (selection: TerminalContextSelection) => void;
  readonly expandedImage: ExpandedImagePreview | null;
  readonly onCloseExpandedImage: () => void;
}): React.ReactElement {
  return (
    <>
      {props.mountedTerminalThreadRefs.map(({ key: mountedThreadKey, threadRef }) => (
        <PersistentThreadTerminalDrawer
          key={mountedThreadKey}
          threadRef={threadRef}
          threadId={threadRef.threadId}
          visible={mountedThreadKey === props.activeThreadKey && props.terminalOpen}
          launchContext={
            mountedThreadKey === props.activeThreadKey
              ? (props.activeTerminalLaunchContext ?? null)
              : null
          }
          focusRequestId={
            mountedThreadKey === props.activeThreadKey ? props.terminalFocusRequestId : 0
          }
          splitShortcutLabel={props.splitTerminalShortcutLabel ?? undefined}
          newShortcutLabel={props.newTerminalShortcutLabel ?? undefined}
          closeShortcutLabel={props.closeTerminalShortcutLabel ?? undefined}
          onAddTerminalContext={props.onAddTerminalContext}
        />
      ))}

      {props.expandedImage ? (
        <ExpandedImageDialog preview={props.expandedImage} onClose={props.onCloseExpandedImage} />
      ) : null}
    </>
  );
}
